import { VpActionChip, VpIcon } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { CustomViewPanel } from '@/components/ProductsGallery/CustomViewPanel'
import { useProductsContext } from '@/contexts/products/useProductsContext'

export function ProductsViewHeaderCustomViewControl() {
  const { t } = useTranslation()
  const { customViewTarget, openCustomView } = useProductsContext()
  const isGallery = customViewTarget === 'gallery'

  return (
    <>
      <VpActionChip
        size="small"
        className="products-view-header__custom-view-chip"
        onClick={openCustomView}
        data-testid={isGallery ? 'custom-view-btn' : 'products-list-custom-view-btn'}
        id={isGallery ? 'product-gallery-custom-view' : undefined}
      >
        <VpIcon name="settings" />
        {t('products-page.custom-view')}
      </VpActionChip>
      <CustomViewPanel />
    </>
  )
}
